import { businessErrorFactory, BusinessError } from '../../../../../../../common/business-error';

import { BUSINESS_ERRORS } from './interfaces';

const INCORRECT_OTP = 'Your OTP codes do not match. Please try again.';

const ORDER_NOT_FOUND =
  // eslint-disable-next-line max-len
  'Sorry we ran into an error while processing your secrets regeneration. Please try again. If the problem still persists, contact with support.';

const OTP_VERIFICATION_UNEXPECTED_ERROR =
  // eslint-disable-next-line max-len
  'Sorry we ran into an unexpected error while processing your secrets regeneration. Please try again. If the problem still persists, contact with support.';

const OTP_EXPIRED =
  'Your OTP codes expired. Please go back to the settings and repeat the operation from the beginning.';

const OTP_DELIVERY_FAILURE =
  // eslint-disable-next-line max-len
  'Sorry we ran into an unexpected error and OTP could not be delivered. Please try again. If the problem still persists, contact with support.';

export const getOtpVerifyBusinessError = (businessError: unknown): BusinessError => {
  switch (businessError) {
    case BUSINESS_ERRORS.INCORRECT_OTP: {
      return businessErrorFactory({ message: INCORRECT_OTP, severity: 'warning' });
    }
    case BUSINESS_ERRORS.ORDER_NOT_FOUND: {
      return businessErrorFactory({ message: ORDER_NOT_FOUND, severity: 'error' });
    }
    case BUSINESS_ERRORS.OTP_EXPIRED: {
      return businessErrorFactory({ message: OTP_EXPIRED, severity: 'warning' });
    }
    case BUSINESS_ERRORS.OTP_DELIVERY_FAILURE: {
      return businessErrorFactory({ message: OTP_DELIVERY_FAILURE, severity: 'error' });
    }
    default: {
      return businessErrorFactory({
        message: OTP_VERIFICATION_UNEXPECTED_ERROR,
        severity: 'error'
      });
    }
  }
};
